<template>
<div class="container-fluid bg-white">
	<safety-toolbar heading="Health & Safety Apps"></safety-toolbar>

	<addon-app-tab ui-location="Health & Safety Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import SafetyToolbar from "./SafetyToolbar"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	components: {
		SafetyToolbar,
		AddonAppTab
	}
}
</script>